<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi"><a id="ch00_fm05_dedi"></a><a id="page_ix"></a>For all of my families</p>
<p class="image"><img alt="image" src="images/common1.jpg"/><a id="page_x"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm05_dedi.vue?da4935e2